import React from "react";
import "./Background.css";

function Background() {
    // Mantenemos los 20 span para tener suficiente densidad visual
    return (
        <div className="background-industrial-v2">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    );
}

export default Background;